export default __webpack_public_path__ + "static/media/twitter.dac14cb2.svg";